module.exports = __webpack_public_path__ + "static/img/brees-2018-slide-5.5c17189.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2018-slide-5.jpg
// module id = oyMD
// module chunks = 1